// The main code of the season: the one without a suffix (SS2027 before SS2027-Pre).
// Pure, no imports — the Collection header, the shell bar and Home's Collection tile read the same rule.
export function seasonCode(season) {
  const codes = Array.isArray(season?.codes) ? season.codes.map(String) : [];
  if (!codes.length) return season?.year ? `SS${season.year}` : null;
  return [...codes].sort((a, b) => a.length - b.length || a.localeCompare(b))[0];
}
